// export const darkTheme = {
//     bg:"#1C1C27",
//     bgLight: "#1C1E27",
//     primary:"#854CE6",
//     text_primary:"#F2F3F4",
//     text_secondary:"#b1b2b3",
//     card:"#171721",
//     card_light: '#191924',
//     button:"#854CE6",
//     white:"#FFFFFF",
//     black:"#000000",
// }

// export const lightTheme = {
//     bg:"#FFFFFF",
//     bgLight: "#f0f0f0",
//     primary:"#be1adb",
//     text_primary:"#111111",
//     text_secondary:"#48494a",
//     card:"#FFFFFF",
//     button:"#5c5b5b",
// }


export const darkTheme = {
  background: "#0F172A",

  bg: "#0F172A",

  bgLight: "#161B22",

  card: "#171721",

  card_light: "#1F2937",

  primary: "#854CE6",

  secondary: "#A855F7",

  white: "#FFFFFF",

  black: "#000000",

  text_primary: "#F8FAFC",

  text_secondary: "#94A3B8",

  text_muted: "#64748B",

  border: "rgba(133,76,230,0.18)",

  button: "#854CE6",

  success: "#22C55E",

  warning: "#F59E0B",

  danger: "#EF4444",

  shadow: "0 10px 40px rgba(0,0,0,.25)",
};

export const lightTheme = {
  background: "#FFFFFF",

  bg: "#FFFFFF",

  bgLight: "#F8FAFC",

  card: "#FFFFFF",

  card_light: "#F1F5F9",

  primary: "#854CE6",

  secondary: "#A855F7",

  white: "#FFFFFF",

  black: "#111827",

  text_primary: "#111827",

  text_secondary: "#475569",

  text_muted: "#64748B",

  border: "rgba(133,76,230,.12)",

  button: "#854CE6",

  success: "#22C55E",

  warning: "#F59E0B",

  danger: "#EF4444",

  shadow: "0 10px 30px rgba(0,0,0,.08)",
};